// La insignia de reseñas del panel de compra baja hasta el widget de Judge.me.
//
// No usa un ancla `href="#..."` porque el widget lo inyecta un BLOQUE DE APP: su contenedor
// lleva un id que compone Shopify y no hay dónde escribir uno propio. Se lo busca por selector.
//
// Los bloques de app no renderizan en `theme dev` ni en la preview del tema Development, así
// que esto se verifica contra el sitio en vivo. Los selectores salieron de leer el HTML real de
// unomas.store: el envoltorio del bloque (`shopify-block-...__judge_me_reviews_review_widget_...`)
// y, dentro, el contenido servido por Judge.me (`.jdgm-ssr-reviews`).

const SELECTORES = [
  '[id*="judge_me_reviews_review_widget"]',
  '.jdgm-rev-widg',
  '.jdgm-ssr-reviews',
  '.jdgm-widget',
];

function buscarResenas() {
  for (const sel of SELECTORES) {
    const el = document.querySelector(sel);
    // Un nodo sin caja no sirve como destino: el widget puede estar en el DOM y todavía vacío.
    if (el && el.getBoundingClientRect().height > 0) return el;
  }
  return null;
}

// El contenedor que scrollea SE BUSCA, no se asume: `.page-wrapper` scrollea sólo en escritorio,
// y por debajo de 990px scrollea el documento. Un `scrollTo` sobre el elemento equivocado no
// hace absolutamente nada y se lee como "el botón no funciona".
function buscarScroller(el) {
  let nodo = el.parentElement;
  while (nodo && nodo !== document.body && nodo !== document.documentElement) {
    const oy = getComputedStyle(nodo).overflowY;
    if ((oy === 'auto' || oy === 'scroll') && nodo.scrollHeight > nodo.clientHeight + 1) return nodo;
    nodo = nodo.parentElement;
  }
  return null;
}

function bajarA(el) {
  const scroller = buscarScroller(el);
  // El alto del encabezado se lee de la variable que `assets/header.js` mantiene en vivo sobre
  // el body: cambia al compactarse, así que un número fijo queda viejo en uno de los dos estados.
  const alto = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
  const margen = (Number.isFinite(alto) ? alto : 60) + 12;
  const suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  if (scroller) {
    const top =
      scroller.scrollTop + el.getBoundingClientRect().top - scroller.getBoundingClientRect().top - margen;
    scroller.scrollTo({ top, behavior: suave });
  } else {
    window.scrollTo({ top: window.scrollY + el.getBoundingClientRect().top - margen, behavior: suave });
  }
}

function conectar(badge) {
  if (badge.dataset.reviewsScrollReady === 'true') return;
  badge.dataset.reviewsScrollReady = 'true';
  badge.addEventListener('click', () => {
    const destino = buscarResenas();
    if (destino) bajarA(destino);
  });
}

// ---------------------------------------------------------------------------------------------
// Ajuste a un solo renglón.
//
// El chip se partía en dos renglones en Firefox de Android. La causa no es un ancho puntual: ahí
// TODO el texto de la ficha sale más grande, así que calibrar contra un breakpoint lo arregla en
// un teléfono y lo rompe en el siguiente. Lo que no entra es el TEXTO, y su largo lo decide el
// merchant (`label` sale del metafield `custom.label`), así que ni una media query ni una
// container query pueden verlo: las dos miden el contenedor. Se mide el desborde real.
//
// Los escalones van de menor a mayor pérdida de información. "verificadas" cae primero por pedido
// del usuario: si acorta la etiqueta y con eso entra todo, el texto completo tiene que volver
// solo — por eso cada ajuste arranca de cero en vez de seguir bajando desde donde quedó.
const ESCALONES = 4;

function aplicarEscalon(badge, n) {
  badge.toggleAttribute('data-fit-hide-verified', n >= 1);
  badge.toggleAttribute('data-fit-hide-label', n >= 2);
  badge.toggleAttribute('data-fit-short-count', n >= 3);
}

function ajustar(badge) {
  // Sin caja no hay nada que medir (aún sin layout, o dentro de algo oculto): dejarlo como está
  // es correcto — el CSS sin `data-fit-ready` envuelve, que es el comportamiento de siempre.
  if (badge.clientWidth === 0) return;

  badge.setAttribute('data-fit-ready', '');

  for (let n = 0; n < ESCALONES; n++) {
    aplicarEscalon(badge, n);
    // +1 de tolerancia: los anchos son sub-píxel y un redondeo hacia arriba haría recortar de más.
    if (badge.scrollWidth <= badge.clientWidth + 1) return;
  }
}

function vigilarAncho(badges) {
  badges.forEach(ajustar);

  // Medir con la tipografía definitiva. Con la fuente de respaldo el ancho es otro y el escalón
  // elegido queda mal — y cuando la real termina de cargar nadie vuelve a mirar, porque el ancho
  // del contenedor no cambió.
  if (document.fonts?.ready) {
    document.fonts.ready.then(() => badges.forEach(ajustar));
  }

  if (typeof ResizeObserver === 'undefined') return;

  // Se observa el PADRE, no el chip. El chip es `width: fit-content`, así que recortarlo le cambia
  // el ancho: observarlo a él sería un bucle de ResizeObserver. El padre da el ancho disponible y
  // no depende de lo que el chip mida.
  //
  // Y va `ResizeObserver` y no `resize` de ventana porque abrir el cajón del carrito le mete 480px
  // de margen a `.page-wrapper` y achica esta columna SIN que `innerWidth` se mueva (CLAUDE.md §6).
  const obs = new ResizeObserver(() => {
    // En un rAF para que la medición ocurra después del layout que disparó el observador.
    requestAnimationFrame(() => badges.forEach(ajustar));
  });
  badges.forEach((b) => {
    if (b.parentElement) obs.observe(b.parentElement);
  });
}

function init() {
  const badges = document.querySelectorAll('.reviews-badge--chip[data-scroll-to-reviews]');
  if (!badges.length) return;

  // Independiente del widget de Judge.me: el chip se ve y tiene que entrar en un renglón exista o
  // no el destino al que baja.
  vigilarAncho(Array.from(badges));

  // Si el widget ya está, se marca enseguida. Si todavía no llegó —lo puede pintar el script de
  // la app después—, se espera con un observador que se desconecta solo: un botón que no lleva
  // a ningún lado es peor que no tener botón.
  const marcar = () => {
    if (!buscarResenas()) return false;
    badges.forEach((b) => {
      b.hidden = false;
      b.classList.add('reviews-badge--linked');
      conectar(b);
    });
    return true;
  };

  if (marcar()) return;

  const obs = new MutationObserver(() => {
    if (marcar()) obs.disconnect();
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 12000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
